import HighlightPulse from "@components/common/animations/HighlightPulse";

export const HighlightBadge = () => {
  return (
    <HighlightPulse
      isActive={true}
      pulseColor="ring-red-500"
      glowColor="shadow-red-500/50"
      borderRadius="rounded-full"
    >
      <Badge />
    </HighlightPulse>
  );
};

export const Badge = () => {
  return (
    <div className="bg-red-500 rounded-full square w-[12px] h-[12px]" />
  );
};

export const HighlightBadgeContainer = ({
  isBadgeVisible = true,
  children,
}) => {
  return (
    <div className="relative">
      {children}

      {isBadgeVisible && (
        <div className="absolute top-0 right-0">
          <HighlightBadge />
        </div>
      )}
    </div>
  );
};
